/**
 * Tracks active session-related modals to coordinate logout behavior.
 * When a session modal is active on the login page, logout triggers a
 * page reload instead of navigation to properly clear modal state.
 */

const activeModals = new Set<string>();

export const sessionModalTracker = {
  track(id: string): void {
    activeModals.add(id);
  },

  untrack(id: string): void {
    activeModals.delete(id);
  },

  hasActiveModals(): boolean {
    return activeModals.size > 0;
  },

  clearAll(): void {
    activeModals.clear();
  },
};
